import axios, { type AxiosInstance } from 'axios';
import { buildDevRoleHeaders, readDevRolePreference } from '@/lib/dev-role-preference';

export interface ApiClientDeps {
  baseURL?: string;
}

/**
 * Build the cockpit axios client. Auth is owned by the backend OIDC session
 * cookie; the SPA does not hold Entra tokens.
 */
export function createApiClient(deps: ApiClientDeps): AxiosInstance {
  const instance = axios.create({
    baseURL: deps.baseURL ?? '/',
    withCredentials: true,
    timeout: 30_000,
  });

  instance.interceptors.request.use((config) => {
    const devHeaders = buildDevRoleHeaders(readDevRolePreference());
    if (Object.keys(devHeaders).length > 0) {
      config.headers = config.headers ?? {};
      for (const [key, value] of Object.entries(devHeaders)) {
        config.headers[key] = value;
      }
    }
    return config;
  });

  return instance;
}
